/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { doc } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import {
  Check,
  RefreshCw,
  Info,
  Truck,
  Shield,
  ArrowRightLeft,
  FileSpreadsheet,
  X,
  Eye,
  EyeOff,
  Lock,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { applyStoreDraft } from "../../redux/store/store";
import { DHD_PLATFORM_URL } from "../DhdCurrentPlanBanner";

export default function ActivationDhd() {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.StoreReducer);
  const { t, i18n } = useTranslation();

  const isConnected =
    store.Uecotrack === DHD_PLATFORM_URL &&
    store.Ecotrack !== null &&
    store.Ecotrack !== "" &&
    store.Ecotrack !== false &&
    store.Ecotrack !== undefined;

  const [showToken, setShowToken] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useStoreFormDraft(store);
  const cleanedRef = useRef(false);

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      Uecotrack: DHD_PLATFORM_URL,
    }));
  }, []);

  useEffect(() => {
    if (cleanedRef.current || !data?.id) return;

    const currentUrl = store.Uecotrack;
    const hasForeignUrl =
      currentUrl &&
      currentUrl !== "" &&
      currentUrl !== false &&
      currentUrl !== DHD_PLATFORM_URL;

    if (hasForeignUrl) {
      cleanedRef.current = true;
      (async () => {
        try {
          const cleared = {
            ...data,
            Uecotrack: "",
            Ecotrack: "",
          };
          await saveStoreDraft(doc(db, "store", data.id), store, cleared);
          dispatch(applyStoreDraft(store, cleared));
          setData((prev) => ({
            ...prev,
            Uecotrack: DHD_PLATFORM_URL,
            Ecotrack: "",
          }));
        } catch (err) {
          console.error("Failed to clear non-DHD Ecotrack credentials:", err);
        }
      })();
    }
  }, [store.Uecotrack, data?.id]);

  const showAlert = (icon, title, text) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText: t("activationCompanies.alerts.confirmButton"),
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `rgba(0,0,0,0.7)`,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        const el = document.querySelector(".swal2-container");
        if (el) el.style.zIndex = "9999999999";
      },
    });
  };

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!data.Ecotrack) {
      await showAlert(
        "warning",
        t("activationCompanies.alerts.missingData.title"),
        t("activationCompanies.alerts.missingData.text"),
      );
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${DHD_PLATFORM_URL}/api/v1/get/communes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${data.Ecotrack}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const payload = {
          ...data,
          Uecotrack: DHD_PLATFORM_URL,
          Ecotrack: data.Ecotrack,
        };
        await saveStoreDraft(doc(db, "store", data.id), store, payload);
        dispatch(applyStoreDraft(store, payload));
        setData(payload);
        await showAlert(
          "success",
          t("activationCompanies.alerts.activationSuccess.title"),
          "",
        );
      } else {
        await showAlert(
          "error",
          t("activationCompanies.alerts.activationFailed.title"),
          t("activationCompanies.alerts.activationFailed.text"),
        );
      }
    } catch (error) {
      console.error("DHD connection error:", error);

      await saveStoreDraft(doc(db, "store", data.id), store, {
        ...data,
        Uecotrack: "",
        Ecotrack: "",
      });

      await showAlert(
        "error",
        t("activationCompanies.alerts.activationError.title"),
        `${error.message} ${t("activationCompanies.alerts.activationError.text")}`,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDeactivate = async () => {
    const result = await Swal.fire({
      icon: "warning",
      title: t("activationCompanies.alerts.deactivateConfirm.title"),
      text: t("activationCompanies.alerts.deactivateConfirm.text"),
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#aaa",
      confirmButtonText: t(
        "activationCompanies.alerts.deactivateConfirm.confirmText",
      ),
      cancelButtonText: t(
        "activationCompanies.alerts.deactivateConfirm.cancelText",
      ),
      backdrop: `rgba(0,0,0,0.7)`,
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        const el = document.querySelector(".swal2-container");
        if (el) el.style.zIndex = "9999999999";
      },
    });

    if (result.isConfirmed) {
      try {
        const updatedData = {
          ...data,
          Uecotrack: "",
          Ecotrack: "",
        };

        await saveStoreDraft(doc(db, "store", data.id), store, updatedData);
        dispatch(applyStoreDraft(store, updatedData));

        setData({
          ...updatedData,
          Uecotrack: DHD_PLATFORM_URL,
        });

        await Swal.fire({
          icon: "success",
          title: t("activationCompanies.alerts.deactivateSuccess.title"),
          text: t("activationCompanies.alerts.deactivateSuccess.text"),
          confirmButtonText: t("activationCompanies.alerts.confirmButton"),
          confirmButtonColor: "rgb(141, 93, 167)",
          customClass: {
            popup: "swal-popup-on-top",
          },
        });
      } catch (error) {
        console.error("Error during DHD deactivation:", error);
        await Swal.fire({
          icon: "error",
          title: t("activationCompanies.alerts.deactivateError.title"),
          text: t("activationCompanies.alerts.deactivateError.text"),
          confirmButtonText: t("activationCompanies.alerts.confirmButton"),
          confirmButtonColor: "rgb(141, 93, 167)",
        });
      }
    }
  };

  return (
    <div className="min-h-[400px] h-fit p-6 bg-white dark:!bg-[#181819] transition-colors duration-300">
      <div className="flex items-center gap-3 mb-4">
        <div className="flex items-center gap-2">
          <h3 className="text-lg font-semibold text-[#9e68ba] dark:text-[#b58fd1] m-0">
            {t("activationCompanies.dhd.title")}
          </h3>
          <span
            className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-bold tracking-wide"
            style={{
              background: "rgba(255, 106, 0, 0.12)",
              color: "#FF6A00",
              border: "1px solid rgba(255, 106, 0, 0.28)",
            }}
          >
            DHD
          </span>
        </div>
      </div>

      <Form onSubmit={handleSubmit}>
        <div className="mb-4">
          <p className="font-medium text-gray-700 mb-3 dark:!text-gray-300">
            {t("activationCompanies.dhd.accountIdLabel")}
          </p>

          <Form.Group className="mb-3">
            <div className="relative mb-3">
              <Form.Control
                type="text"
                value={DHD_PLATFORM_URL}
                disabled
                readOnly
                className="mb-3 border-gray-300 rounded-lg p-2 pr-12
                     placeholder-gray-400 dark:!placeholder-gray-500
                     dark:!border-[#3c3a3d] dark:!bg-[#222] dark:!text-gray-400
                     focus:ring-0 cursor-not-allowed opacity-90 mr-[32px]"
                style={{
                  direction: "ltr",
                  textAlign: "left",
                  width: "94%",
                }}
              />
              <div
                className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 dark:text-gray-500"
                title={t("activationCompanies.dhd.urlLocked")}
              >
                <Lock size={16} />
              </div>
            </div>

            <div className="relative mb-3">
              <Form.Control
                type={showToken ? "text" : "password"}
                placeholder={t("activationCompanies.dhd.tokenPlaceholder")}
                value={data.Ecotrack || ""}
                onChange={(e) => setData({ ...data, Ecotrack: e.target.value })}
                className="mb-3 border-gray-300 rounded-lg p-2 pr-12
                     placeholder-gray-400 dark:!placeholder-gray-500
                     dark:!border-[#3c3a3d] dark:!bg-[#181819] dark:!text-gray-200
                     focus:ring-2 focus:ring-[#9e68ba] mr-[32px]"
                style={{
                  direction: i18n.dir(),
                  textAlign: i18n.dir() === "rtl" ? "right" : "left",
                  width: "94%",
                }}
              />
              <button
                type="button"
                onClick={() => setShowToken(!showToken)}
                className="absolute inset-y-0 right-0 flex items-center pr-3
                  text-gray-500 hover:text-[#9e68ba] dark:text-gray-400"
              >
                {showToken ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>

            <Form.Text className="text-muted dark:!text-gray-400">
              {t("activationCompanies.dhd.helperText")}
            </Form.Text>
          </Form.Group>
        </div>

        <div className="bg-[#fcf6ff] dark:!bg-[#181819] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-4">
          <h4 className="font-medium text-[#9e68ba] dark:!text-[#b58fd1] mb-2 d-flex align-items-center text-xl">
            <Info size={18} className="ml-2" />
            {t("activationCompanies.dhd.tipsTitle")}
          </h4>
          <ul className="text-sm text-gray-700 dark:!text-gray-300 space-y-2 mr-5 list-disc">
            <li className="d-flex align-items-start mb-2">
              <Truck
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>{t("activationCompanies.dhd.tips.0")}</span>
            </li>
            <li className="d-flex align-items-start mb-2">
              <Shield
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>{t("activationCompanies.dhd.tips.1")}</span>
            </li>
            <li className="d-flex align-items-start mb-2">
              <ArrowRightLeft
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>{t("activationCompanies.dhd.tips.2")}</span>
            </li>
            <li className="d-flex align-items-start">
              <FileSpreadsheet
                size={16}
                className="text-[#9e68ba] ml-2 mt-1 flex-shrink-0"
              />
              <span>{t("activationCompanies.dhd.tips.3")}</span>
            </li>
          </ul>
        </div>

        <div className="d-flex justify-content-between mt-4">
          {!isConnected ? (
            <Button
              type="submit"
              disabled={loading}
              className="d-flex align-items-center justify-content-center dark:!bg-[#9e68ba] dark:hover:bg-[#814a9f] dark:!border-[#9e68ba]"
              style={{
                backgroundColor: "rgb(141, 93, 167)",
                borderColor: "rgb(141, 93, 167)",
                opacity: loading ? 0.7 : 1,
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.2s ease",
                borderRadius: "0.5rem",
                padding: "0.5rem 1.5rem",
                minWidth: "150px",
              }}
            >
              {loading ? (
                <>
                  <RefreshCw className="animate-spin ml-2" size={18} />
                  {t("activationCompanies.dhd.submitting")}
                </>
              ) : (
                <>
                  <Check className="ml-2" size={18} />
                  {t("activationCompanies.dhd.submit")}
                </>
              )}
            </Button>
          ) : (
            <Button
              variant="danger"
              className="d-flex align-items-center justify-content-center dark:!bg-red-600 dark:hover:bg-red-700"
              onClick={handleDeactivate}
              style={{
                borderRadius: "0.5rem",
                padding: "0.5rem 1.5rem",
                minWidth: "150px",
              }}
            >
              <X className="ml-2" size={18} />
              {t("activationCompanies.dhd.cancel")}
            </Button>
          )}
        </div>
      </Form>
    </div>
  );
}
